
<template>
    <figure class="packet-wrap"
        :class="{
            [disabled ? 'disabled' : 'normal']: true, 
            clicked: !!clicked, 
        }"
    >
        <img class="bg-img" 
            :src="sPackImgSrc"
        />
        <span class="self-mark"
            v-if="info.sentByMe && !animationCard" 
        >
            {{ $t('redPacketMines.myPacket') }} 
        </span>
        <!--
            ↑ 背景图 
            ↓ 内容 
        -->
        <div class="content">
            <p class="rest-qty">
                {{ $t('redPacketMines.packetsRest').split('●')[0] }}
                <em>
                    {{ info?.totalAccount || 0 }} 
                </em>
                {{ $t('redPacketMines.packetsRest').split('●')[1] }}
            </p>
            <h5 class="title">
                <em>
                    {{ iType }}
                </em>
                <small>
                    {{ $t('redPacketMines.packetsShortened') }}
                </small>
            </h5>
            <button class="fake-btn">
                {{ $t('redPacketMines.Grab') }}
            </button>
            <div class="info">
                <p class="amount-badge">
                    <span class="amount">
                        <CurrentCoin
                            class="inline-block"
                            :name="info.currency"
                            size="10px"
                        />
                        &nbsp;
                        <span>
                            {{ amount }}
                        </span>
                    </span> 
                </p>
                <div class="last-bar">
                    <span class="odds">
                        {{ $t('redPacketMines.Odds') }}
                        x<em>{{ info?.sRate || '' }}</em>
                    </span>
                    <span class="number">
                        {{ $t('redPacketMines.BombNumber')}}
                        <em>
                            {{
                                (info.gid && info.mine >= 0)
                                ? info.mine
                                : 'x'
                            }}
                        </em>
                    </span>
                </div>
            </div>
            <Transition name="rising">
                <img src="@/pages/casino/redpacketGame/img/cursor.png" 
                    class="cursor"
                    v-show="!!clicked"
                />
            </Transition>
        </div>
    </figure>
</template>

<script lang="ts" setup>
import packetL01 from '@/pages/casino/redpacketGame/img/gate_and_pecket/packet-level_1.webp';
import packetL02 from '@/pages/casino/redpacketGame/img/gate_and_pecket/packet-level_2.webp';
import packetL03 from '@/pages/casino/redpacketGame/img/gate_and_pecket/packet-level_3.webp';
import type { PacketQty } from '../ts/redPacketCommon'; 

const props = defineProps({
    iType: {
        type: Number as PropType<PacketQty>,
        required: true, 
    },
    disabled: {
        type: Boolean,
    },
    clicked: {
        type: Boolean,
    },
    bobmNumber: {
        type: Number,
    },
    amount: {
        type: [Number, String],
        // required: true,
    },
    info: {
        type: Object,
        default: () => ({}),
    },
    animationCard: { // 表示用于动画展示的卡片 
        type: Boolean,
    },
});

const oPic = {
    '5': packetL01,
    '8': packetL02,
    '10': packetL03,
};
const sPackImgSrc = computed(()=>{
    const sType = String(props.iType);
    const src = oPic[sType];
    return src; 
});

// onMounted(()=>{

// });

</script>

<style scoped lang="scss" >
.packet-wrap{
    --radius: 35px;
    min-width: 90px; 
    min-height: 100px; 
    max-width: min(45vw, 200px); 
    position: relative; 
    font-size: 10px;
    transition: all 0.3s; 

    &.clicked,
    &.normal:active{
        transform: translateY(4px); 
    }
    &.clicked,
    &.normal:hover, 
    &.normal:active{
        .bg-img{
            box-shadow: 0px 0px 0px 3px #FFEDB5; 
        }
    }
    &.disabled{
        opacity: 1 !important; 
        filter: brightness(0.5);
    }
}

@media screen and (max-width: 380px){
    .packet-wrap{
        --radius: 20px;
        font-size: 9px; 
    }
}

.self-mark{
    z-index: 2; 
    position: absolute; 
    top: 0;
    left: 50%; 
    transform: translate(-50%, calc(-100% + 3px)); 
    min-height: 20px; 
    line-height: 20px; 
    background: linear-gradient(180deg, #FB1949 -14.24%, #C4003B 126.1%);
    border-radius: 8px; 
    border-bottom-left-radius: 0px; 
    padding: 0 8px;
    color: white; 
    white-space: nowrap; 
    font-size: 10px; 
}

.bg-img{
    overflow: hidden; 
    border-radius: var(--radius); 
    transition: all 0.3s; 
}

.content{
    border-radius: var(--radius); 
    overflow: hidden; 
    position: absolute; 
    top: 0;
    bottom: 0;
    left: 0;
    right: 0; 
    user-select: none; 
    text-align: center; 
    display: flex;
    flex-direction: column;
    color: white; 
    & > *{
        display: flex;
        justify-content: center; 
        align-items: center; 
        // box-shadow: 0px 0px 5px blue; 
        min-height: 5px; 
        text-align: center; 
        position: absolute; 
        user-select: none; // 重要 
    }
    .rest-qty{
        width: 100%; 
        font-weight: 500;
        font-size: 1em;
        line-height: 1.2;
        top: 9%; 
        background: linear-gradient(177.91deg, #FFF0CB 1.76%, #FFCE85 115.06%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        // font-size: 30px;
        em{
            font-size: 1.6em; 
            padding: 0 0.2em; 
            font-weight: bold; 
        }
    }
    .title{
        top: 20%; 
        width: 100%;
        height: 22%;
        color: white; 
        em{
            margin-right: 3px;
            font-size: 2.9em; 
            font-weight: 900;
        }
        small{
            font-size: 1.9em;
            padding-top: 3px;
            font-weight: 900; 
        }
    }
    .fake-btn{
        top: 42%;  
        height: 24.5%;
        display: flex; 
        justify-content: center; 
        align-items: center; 
        width: 100%; 
        font-size: 1.8em;
        line-height: 1.1; 
        font-weight: 900; 
        color: #C05B09; 
        text-shadow: 1px 1px 1px rgb(0 0 0 / 0.5);
        text-transform: uppercase;
    }
    .info{
        bottom: 6%;
        left: 0;
        right: 0;
        width: 100%; 
        flex-direction: column; 
        .amount-badge{
            width: 100%; 
            padding: 0 0 3px;
            .amount{
                font-weight: 700;
                border-radius: 200px; 
                color: rgba(250, 196, 133, 1);
                background: rgba(0, 0, 0, 0.3);
                margin: 0 auto;
                padding: 0 5px;
                display: inline-flex; 
                align-items: center; 
                justify-content: center; 
            }
        }
        .last-bar{
            display: flex; 
            justify-content: center; 
            span{
                border-radius: 200px;
                font-size: 0.9em; 
                padding: 0 4px; 
                line-height: 1.2; 
                &.odds{
                    color: rgba(152, 14, 40, 1);
                    background: linear-gradient(177.91deg, #FFB32F 1.76%, #FFEC41 115.06%);
                    margin: 0 5px 0 0; 
                }
                &.number{
                    color: rgba(167, 181, 202, 1);
                    background: rgba(0, 0, 0, 0.7);
                }
                em{
                    font-size: 1.3em;
                    font-weight: bold;  
                }
            }
        }
    }
    .cursor{
        position: absolute; 
        top: 50%;
        left: 45%; 
        width: 20px; 
    }
}


.rising-enter-active {
    transition: all 0.3s linear; 
}
.rising-leave-active{
    transition: all 0.3s linear; 
}

.rising-enter-from{
    transform: translateX(50px) translateY(90px);
    opacity: 1;
}

.rising-enter-to {
    opacity: 0.2;
    transform: translateX(0) translateY(0);
}


</style>

